var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 10,
    fill: "#434343"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 20.6668C21.1046 20.6668 22 19.7714 22 18.6668C22 17.5623 21.1046 16.6668 20 16.6668C18.8954 16.6668 18 17.5623 18 18.6668C18 19.7714 18.8954 20.6668 20 20.6668Z",
    stroke: "#2EC99E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 26.6668C22.6667 24.0002 25.3333 21.6123 25.3333 18.6668C25.3333 15.7213 22.9455 13.3335 20 13.3335C17.0545 13.3335 14.6667 15.7213 14.6667 18.6668C14.6667 21.6123 17.3333 24.0002 20 26.6668Z",
    stroke: "#2EC99E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenLocation);
export default __webpack_public_path__ + "static/media/green-location.61932a584403a61cc3e5cc3aab2e9e36.svg";
export { ForwardRef as ReactComponent };